<div #graphContainer class="h-full w-full overflow-hidden bg-white dark:bg-zinc-900">
  <div
    #graphElement
    class="h-full w-full p-4"
    [attr.data-context]="
      showMenuOnRightClick() ? 'planning-space-graph-menu' : 'planning-space-graph'
    "></div>
</div>
